import React from 'react';
import AdminWrapper from '../components/layout/AdminWrapper';
import EventsList from './EventsList';

const AdminEventsList = () => (
  <AdminWrapper>
    <EventsList />
  </AdminWrapper>
);

export default AdminEventsList;
